import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import AuthHeader from '../../components/ui/AuthHeader';
import Icon from '../../components/AppIcon';
import CurrentPlanTab from './components/CurrentPlanTab';
import PaymentHistoryTab from './components/PaymentHistoryTab';
import UpgradeOptionsTab from './components/UpgradeOptionsTab';

const BillingManagement = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('current-plan');

  const tabs = [
    { id: 'current-plan', label: 'Current Plan', icon: 'Package' },
    { id: 'payment-history', label: 'Payment History', icon: 'Receipt' },
    { id: 'upgrade-options', label: 'Upgrade Options', icon: 'TrendingUp' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'current-plan':
        return <CurrentPlanTab />;
      case 'payment-history':
        return <PaymentHistoryTab />;
      case 'upgrade-options':
        return <UpgradeOptionsTab />;
      default:
        return <CurrentPlanTab />;
    }
  };

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar isCollapsed={isSidebarCollapsed} userSubscription="growth" />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <AuthHeader 
          onToggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          isSidebarCollapsed={isSidebarCollapsed}
        />
        
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto space-y-6">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground font-heading">
                  Billing & Subscription
                </h1>
                <p className="text-sm text-muted-foreground font-caption mt-1">
                  Manage your subscription, payment methods, and billing history
                </p>
              </div>
              <div className="flex items-center gap-2">
                <div className="px-3 py-1.5 bg-success/10 border border-success/20 rounded-md">
                  <span className="text-xs font-medium text-success font-caption">
                    Active Subscription
                  </span>
                </div>
              </div>
            </div>

            {/* Tabs Navigation */}
            <div className="bg-card border border-border rounded-lg p-2 elevation-sm overflow-x-auto">
              <div className="flex gap-2 min-w-max md:min-w-0">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium font-body transition-smooth whitespace-nowrap ${
                      activeTab === tab?.id
                        ? 'bg-primary text-primary-foreground elevation-sm'
                        : 'text-muted-foreground hover:bg-muted/50'
                    }`}
                  >
                    <Icon name={tab?.icon} size={16} />
                    {tab?.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="space-y-6">
              {renderTabContent()}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BillingManagement;